/* Qlean PDP v2 - cart drawer upgrade band. Delegated handler, so it survives the drawer re-rendering itself. */
(function () {
  'use strict';
  if (window.__qoCartBound) return;
  window.__qoCartBound = true;

  function json(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } }, opts || {}))
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Cart error'); return j; }); });
  }

  function drawerSectionId() {
    var d = document.querySelector('cart-drawer');
    var sec = d && d.closest('.shopify-section');
    var id = sec && sec.id ? sec.id.replace(/^shopify-section-/, '') : '';
    return id || 'cart-drawer';
  }

  /* The theme drawer, the header count and the free-shipping bar all listen to cart:change and expect the
     FULL cart JSON plus rendered sections - /cart/update.js with a sections param returns exactly that. */
  function refreshDrawer() {
    var sid = drawerSectionId();
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ sections: sid }) })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var drawer = document.querySelector('cart-drawer');
        var html = cart.sections && cart.sections[sid];
        if (drawer && html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('cart-drawer');
          if (fresh) { drawer.innerHTML = fresh.innerHTML; drawer.className = fresh.className; }
        }
        try { document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cart } })); } catch (e) {}
        if (drawer) { if (typeof drawer.show === 'function') drawer.show(); else drawer.setAttribute('open', ''); }
      });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('cart-drawer [data-qo-add]');
    if (!a || a.disabled) return;
    var vid = parseInt(a.getAttribute('data-qo-add'), 10);
    if (!vid) return;
    a.disabled = true;
    try { if (window.posthog) window.posthog.capture('pdp_v2_cart_addon_add', { variant: vid }); } catch (err) {}
    json('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }) })
      .then(refreshDrawer)
      .catch(function (err) { alert(err.message); a.disabled = false; });
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qo-upgrade]');
    if (!b || b.disabled) return;
    var key = b.getAttribute('data-line-key');
    var variant = parseInt(b.getAttribute('data-variant'), 10);
    var plan = parseInt(b.getAttribute('data-plan'), 10) || 0;
    var gift = parseInt(b.getAttribute('data-gift'), 10) || 0;
    if (!key || !variant) return;
    b.disabled = true;
    var items = [{ id: variant, quantity: 1 }];
    if (plan) items[0].selling_plan = plan;
    if (gift) items.push({ id: gift, quantity: 1 });
    try { if (window.posthog) window.posthog.capture('pdp_v2_cart_upgrade', { to_variant: variant, plan: plan }); } catch (err) {}
    json('/cart/change.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: 0 }) })
      .then(function () { return json('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: items }) }); })
      .then(refreshDrawer)
      .catch(function (err) { alert(err.message); b.disabled = false; });
  });
})();
